import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-background-50 whitespace-nowrap cursor-pointer">
              {siteInfo.name}
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="GitHub">
                <i className="ri-github-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="RSS">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">全部分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-map-pin-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                北京市海淀区中关村
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-time-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                周一至周五 9:00-18:00
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-secondary-400 mb-2">关注我们，获取最新内容</p>
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  placeholder="输入您的邮箱"
                  className="px-3 py-1.5 text-xs bg-secondary-800 border border-secondary-700 rounded-md text-background-50 placeholder:text-secondary-500 focus:outline-none focus:border-primary-400 w-full"
                />
                <button className="px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  订阅
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-secondary-500">
            本站资源仅供学习交流，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}